import { render } from "./OpenSearchTableFilter.vue?vue&type=template&id=4478d34b&scoped=true"
import script from "./OpenSearchTableFilter.vue?vue&type=script&lang=js"
export * from "./OpenSearchTableFilter.vue?vue&type=script&lang=js"

import "./OpenSearchTableFilter.vue?vue&type=style&index=0&id=4478d34b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4478d34b"]])

export default __exports__